module.exports = __webpack_public_path__ + "media/tv-t2_glej-na-vseh-napravah_screen_3_compressed-2.665b073f.mp4";